import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';

/**
 * 내 소식 항목 삭제
 *
 * Origin: pageNicolasApi.removeMyNews
 * API: POST /api/v5/store/remove/my_news
 */
export async function postStoreRemoveMyNews(
  {
    newsId,
  }: {
    newsId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v5/store/remove/my_news',
    {
      method: 'POST',
      data: {
        news_id: newsId,
      },
    },
    options
  );
  return response.data;
}
